import React from 'react';
import { TextField, IconButton } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';

/** Buscador inline reutilizable (estilos globales `table-search-inline` en App.css). */
export default function SearchInput({ value, onChange, placeholder = 'Buscar...' }) {
    return (
        <TextField
            variant="outlined"
            size="small"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className="table-search-inline"
            InputProps={{
                startAdornment: <SearchIcon fontSize="small" />,
                endAdornment: (
                    <IconButton
                        size="small"
                        className={value ? 'table-search-clear-visible' : 'table-search-clear-hidden'}
                        onClick={() => onChange('')}
                    >
                        <ClearIcon fontSize="small" />
                    </IconButton>
                ),
            }}
        />
    );
}
